<div class="col-md-10 offset-1">
  <br />
  <br />
  <h3>
    <b>{{data.sheetTitle}}</b>
  </h3>
  <br />
  <div [innerHTML]="data.sheetText">
  </div>

  <h5><b>General Instructions</b></h5>
  <div [innerHTML]="data.protocolData.generalInstructions"></div>
  <br />
  <h5><b>Background</b></h5>
  <div [innerHTML]="data.protocolData.background"></div>
  <br />
  <div *ngFor="let section of data.sectionData; let si = index">
    <h5><b>{{section.title}}</b></h5>
    <div [innerHTML]="section.descriptionHtml"></div>

    <div *ngIf="section.isCollapsed">
      <div *ngFor="let column of section.sectionColumn">
        <div *ngIf="column.title!='Default'">
          <h6><b>{{column.title}}</b></h6>
          <div [innerHTML]="column.descriptionHtml"></div>
        </div>
      </div>
      <div *ngFor="let sectionItem of section.sectionItem">
        <h6><b>{{sectionItem.title}}</b></h6>
        <div [innerHTML]="sectionItem.descriptionHtml"></div>
      </div>
    </div>
    <br />
  </div>
</div>
<br />
<br />



